import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"

export const useAuthCheck = () => {
    const { token, loading } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        if (loading) return
        if (!token) {
            navigate("/")
        }
    }, [token, loading, navigate])
}
